import hash from "@emotion/hash"
import { css } from "@emotion/react"

export const testimoneeGradientVar = `--${hash("testimonee:gradient")}`

export const colors = css`
  .tcs${hash("all")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(6, 90, 52), rgb(82, 158, 124));
  }

  .tcs${hash("tennis")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(155, 77, 50), rgb(177, 114, 92));
  }

  .tcs${hash("golf")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(27, 71, 53), rgb(15, 117, 71));
  }

  .tcs${hash("yachting")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(25, 79, 130), rgb(74, 132, 186));
  }

  .tcs${hash("motor_sport")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(123, 32, 39), rgb(191, 86, 94));
  }

  .tcs${hash("equestrianism")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(95, 68, 45), rgb(160, 113, 73));
  }

  .tcs${hash("ski")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(155, 155, 155), rgb(199, 199, 199));
  }

  .tcs${hash("exploration")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(46, 107, 132), rgb(81, 166, 201));
  }

  .tcs${hash("cinema")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(33, 33, 33), rgb(99, 96, 96));
  }

  .tcs${hash("culture")} {
    ${testimoneeGradientVar}: linear-gradient(270deg, rgb(163, 126, 44), rgb(187, 166, 121));
  }
`
